import React from "react";
import PropTypes from "prop-types";
import jsonData from "../../../../current-survey-numeric.json"; // Ensure the path is correct

const RespondentsSummary = ({ filterCriteria }) => {
  // Split respondents by current and previous surveys
  const currentSurveyId = "engagement_2025";
  const previousSurveyId = "engagement_2023"; // Adjust as needed for your previous survey ID

  const currentSurveyRespondents = jsonData.filter(
    (item) => item.survey_id === currentSurveyId
  );
  const previousSurveyRespondents = jsonData.filter(
    (item) => item.survey_id === previousSurveyId
  );

  const currentSurveyFiltered = currentSurveyRespondents.filter((item) => {
    return Object.keys(filterCriteria).every((key) => {
      if (!filterCriteria[key] || filterCriteria[key].length === 0) return true;
      return filterCriteria[key].includes(item[key]);
    });
  });

  const previousSurveyFiltered = previousSurveyRespondents.filter((item) => {
    return Object.keys(filterCriteria).every((key) => {
      if (!filterCriteria[key] || filterCriteria[key].length === 0) return true;
      return filterCriteria[key].includes(item[key]);
    });
  });

  return (
    <div className="respondents-summary">
      <div className="respondents-total">
        <h3>Current Survey Respondents:</h3>
        <p>{currentSurveyRespondents.length}</p>
      </div>
      <div className="respondents-filtered">
        <h3>Current Survey Filtered:</h3>
        <p>{currentSurveyFiltered.length}</p>
      </div>
      {/* <div className="respondents-total">
        <h3>Previous Survey Respondents:</h3>
        <p>{previousSurveyRespondents.length}</p>
      </div>
      <div className="respondents-filtered">
        <h3>Previous Survey Filtered:</h3>
        <p>{previousSurveyFiltered.length}</p>
      </div> */}
    </div>
  );
};

RespondentsSummary.propTypes = {
  filterCriteria: PropTypes.object.isRequired,
};

export default RespondentsSummary;
